import React, { useState } from 'react'

import { motion } from 'framer-motion'

import { animationConfig } from './animationConfig'

export const TypewriterText = ({
  text,
  duration = 1,
  config,
}: {
  text: string
  duration: number
  config: ReturnType<typeof animationConfig>
}) => {
  const [displayedText, setDisplayedText] = useState('')
  const [isComplete, setIsComplete] = useState(false)
  const [isActive, setIsActive] = useState(false)

  React.useEffect(() => {
    // Reset state when text changes
    setDisplayedText('')
    setIsComplete(false)
    setIsActive(true)

    const typewriterDuration = config.timings.typewriterSpeed * 1000
    const charDelay = typewriterDuration / text.length

    let currentIndex = 0
    const typeInterval = setInterval(() => {
      if (!isActive) {
        clearInterval(typeInterval)
        return
      }

      if (currentIndex <= text.length) {
        setDisplayedText(text.slice(0, currentIndex))
        currentIndex++
      } else {
        setIsComplete(true)
        clearInterval(typeInterval)
      }
    }, charDelay)

    return () => {
      clearInterval(typeInterval)
      setIsActive(false)
    }
  }, [text, isActive])

  return (
    <motion.div
      key={`typewriter-${text}`}
      style={{
        marginLeft: 32,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        color: '#ffffff',
        fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: '22px',
        lineHeight: '28px',
        letterSpacing: '-1%',
        whiteSpace: 'nowrap',
        position: 'relative',
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {displayedText}
      {!isComplete && (
        <motion.span
          style={{
            color: '#ffffff',
            marginLeft: '2px',
          }}
          animate={{ opacity: [1, 0] }}
          transition={{
            duration: 0.5,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        >
          |
        </motion.span>
      )}
    </motion.div>
  )
}
